export const setPasswordDefault = (value) => ({
  type: 'SET_PASS',
  value,
});
